<template>
  <hm-content title="">
    <div class="table-panel flex flex-start item-center">
      <div>
        <el-select
          v-model="searchCondition.takeType"
          filterable
          placeholder="请选择取货类型"
          size="small"
          clearable
          class="mr10 mb10"
          @change="search"
        >
          <el-option
            v-for="item in settleState_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="searchCondition.takeStatus"
          filterable
          placeholder="请选择跨店调拨状态"
          size="small"
          clearable
          class="mr10"
          @change="search"
        >
          <el-option
            v-for="item in takeStatus_options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          size="small"
          v-model="searchCondition.dateValue"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="mr10 mb10"
          @change="search"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.batchSeq"
          placeholder="请输入订单号"
          size="small"
          class="ipt mr10 mb10"
        ></el-input>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.handlerBy"
          placeholder="请输入经手人"
          size="small"
          class="ipt mr10 mb10"
        ></el-input>
      </div>
      <div class="flex item-center mr10 pointer ml10" @click="drawer = true">
        <div class="more-search">更多筛选</div>
        <div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="primary"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="inputDeep">
      <el-table :data="tableData" empty-text="没有数据" stripe style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="batchSeq"
          label="取货单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="delFlag"
          label="跨店调拨状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.takeStatus == 'success'" class="success"
              >成功</span
            >
            <span v-if="scope.row.takeStatus == 'fail'" class="danger">失败</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="货号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSize"
          label="规格"
        >
          <template slot-scope="scope">
            {{ scope.row.goodsSize }} {{ scope.row.goodsColor }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="takeOrgName"
          label="取货门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="depositOrgName"
          label="寄存门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="takeNum"
          label="取货数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actuallyTakeNum"
          label="实际提取数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="takeType"
          label="取货类型"
        >
          <template slot-scope="scope">
            {{ scope.row.takeType == "otherShop" ? "跨店取货" : "本店取货" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="takeMode"
          label="取货方式"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.takeMode == 'mobile'">手机号取货</span>
            <span v-if="scope.row.takeMode == 'qrcode'">扫一扫取货</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="取货经手人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="取货时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="取货会员"
        >
          <template slot-scope="scope">
            {{ scope.row.memberName }}/{{ scope.row.memberMobile }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="errorInfo"
          label="取货流程"
        >
        <template slot-scope="scope" v-if="scope.row.takeStatus == 'success'">
            <el-button size="small" type="text" @click="errMsg(scope,'取货流程')"
              >取货流程</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="id"
          label="操作"
        >
          <template slot-scope="scope" v-if="scope.row.takeStatus == 'fail' || scope.row.takeStatus == 'proc'">
            <el-button size="small" type="text" @click="errMsg(scope,'异常原因')"
              >异常原因</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-drawer
      title="更多筛选"
      :visible.sync="drawer"
      direction="rtl"
      size="730px"
    >
      <!-- <el-drawer
      title="更多筛选"
      :visible.sync="drawer"
      direction="rtl"
      size="590px"
    > -->
      <div class="drawer-search shop-list">
        <div class="flex flex-wrap">
          <el-select
            v-model="searchCondition.takeType"
            filterable
            placeholder="请选择取货类型"
            size="small"
            clearable
            class="mr10 mb10"
          >
            <el-option
              v-for="item in settleState_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="searchCondition.takeStatus"
            filterable
            placeholder="请选择跨店调拨状态"
            size="small"
            clearable
            class="mr10"
            @change="search"
          >
            <el-option
              v-for="item in takeStatus_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
            size="small"
            v-model="searchCondition.dateValue"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="mr10 mb10"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.batchSeq"
            placeholder="请输入订单号"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.handlerBy"
            placeholder="请输入经手人"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.memberInfo"
            placeholder="请输入会员姓名/手机号"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.takeOrgName"
            placeholder="请输入取货门店"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.depositOrgName"
            placeholder="请输入寄存门店"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.goodsName"
            placeholder="商品名称"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.goodsSn"
            placeholder="商品货号"
            size="small"
            class="ipt mr10 mb10"
          ></el-input>
        </div>

        <div class="flex flex-end">
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
    </el-drawer>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  name: "storeFinanceDayStatInfo",
  data() {
    return {
      drawer: false,
      isOutputing: false,
      total: 0,
      settleState_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "otherShop",
          label: "跨店取货",
        },
        {
          value: "currentShop",
          label: "本店取货",
        },
      ],
      takeStatus_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "success",
          label: "跨店调拨已完成",
        },
        {
          value: "proc",
          label: "跨店调拨未完成",
        },
        {
          value: "fail",
          label: "跨店调拨失败",
        },
      ],
      state_options: [
        {
          value: "otherShop",
          label: "跨店取货",
        },
        {
          value: "currentShop",
          label: "本店取货",
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      searchCondition: {
        settleState: "",
        dateValue: "",
      },
      tableData:[],
      currentPage: 1,
      pageSize: 10,
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const { storeCode } = getLoginUser();
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // if (this.isArray(searchCondition.dateValue)) {
      //   searchCondition.queryStartDate =
      //     searchCondition.dateValue && searchCondition.dateValue.length > 0
      //       ? searchCondition.dateValue[0] + " 00:00:00"
      //       : "";
      //   searchCondition.queryEndDate =
      //     searchCondition.dateValue && searchCondition.dateValue.length > 0
      //       ? searchCondition.dateValue[1] + " 23:59:59"
      //       : "";
      // }
      if (this.isArray(searchCondition.dateValue)) {
        searchCondition.beginDate =
          searchCondition.dateValue && searchCondition.dateValue.length > 0
            ? searchCondition.dateValue[0] + " 00:00:00"
            : "";
        searchCondition.endDate =
          searchCondition.dateValue && searchCondition.dateValue.length > 0
            ? searchCondition.dateValue[1] + " 23:59:59"
            : "";
      }
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGoodsDetailsPageList",
        params
      );
      const { records, total } = result;
      this.tableData = records;
      this.total = total;
    },
    async queryAllList() {
      const { storeCode } = getLoginUser();
      let params = {
        pageNo: this.currentPage,
        pageSize: 9999999,
        storeCode: storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (this.isArray(searchCondition.dateValue)) {
        searchCondition.beginDate =
          searchCondition.dateValue && searchCondition.dateValue.length > 0
            ? searchCondition.dateValue[0] + " 00:00:00"
            : "";
        searchCondition.endDate =
          searchCondition.dateValue && searchCondition.dateValue.length > 0
            ? searchCondition.dateValue[1] + " 23:59:59"
            : "";
      }
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryGoodsDetailsPageList",
        params
      );
      const { records, total } = result;
      this.tableData = records;
      this.total = total;
    },
    // 查看异常信息
    async errMsg(scope,name) {
      let params = JSON.parse(JSON.stringify(scope.row));
      params.errorInfo = params.errorInfo.replace(/(\r\n|\n)/g, '<br/>');
      this.$alert(params.errorInfo, name, {
        customClass: 'message-goodsDetails',
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      });
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const { storeCode } = getLoginUser();
        let params = {
          pageNo: this.currentPage,
          pageSize: 9999999,
          storeCode: storeCode,
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        if (this.isArray(searchCondition.dateValue)) {
          searchCondition.beginDate =
            searchCondition.dateValue && searchCondition.dateValue.length > 0
              ? searchCondition.dateValue[0] + " 00:00:00"
              : "";
          searchCondition.endDate =
            searchCondition.dateValue && searchCondition.dateValue.length > 0
              ? searchCondition.dateValue[1] + " 23:59:59"
              : "";
        }
        Object.assign(params, searchCondition);
        this.$store
          .dispatch("queryGoodsDetailsPageList", params)
          .then((res) => {
            // const list = this.activityCenterAllList.records;
            console.log(res);
            const list = res.result.records;
            list.forEach((v) => {
              if (v.takeType == "otherShop") {
                v.takeType = "跨店取货";
              } else {
                v.takeType = "本店取货";
              }
              if (v.takeStatus == "success") {
                v.takeStatus = "成功";
                v.errorInfo = "";
              } else {
                v.takeStatus = "失败";
              }
              v.goodsSize = v.goodsSize + " " + v.goodsColor;
            });
            console.log(list);
            const tHeader = [
              "取货单号",
              "跨店调拨状态",
              "商品名称",
              "货号",
              "规格",
              "取货门店",
              "寄存门店",
              "取货数量",
              "取货类型",
              "取货经手人",
              "取货时间",
              "取货会员",
              "异常原因",
            ];
            const filterVal = [
              "batchSeq",
              "takeStatus",
              "goodsName",
              "goodsSn",
              "goodsSize",
              "takeOrgName",
              "depositOrgName",
              "takeNum",
              "takeType",
              "createBy",
              "createTime",
              "memberName",
              "errorInfo",
            ];
            const data = this.formatJson(filterVal, list);
            console.log(data);
            exportJsonToExcel(
              tHeader,
              data,
              "寄存取货流水" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style scoped lang="scss">
.inputDeep >>> .el-input__inner {
  border: 0;
  background: none;
}
.errorInfo{
  overflow: hidden;
}
</style>
<style>
.message-goodsDetails{
  width: 1500px !important;
}
</style>